module.exports = __webpack_public_path__ + "img/topImg-4.5639b8d6.png";